import Swal from 'sweetalert2';
import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { UIActions } from '../../presentation/redux/actions/UIActions';

/* eslint-disable no-unused-vars */
export const recoveryPassword = async (pointOfSaleToRecovery, setMailRecovery, dispatch) => {
    try {
        const params = new URLSearchParams({
            pointOfSale: pointOfSaleToRecovery
        });
        const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/recovery/password?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    setMailRecovery(data.data.mail_part);
                } else {
                    Swal.fire('Error', data.userMessage, 'error');
                }
            });
    } catch (error) {
        Swal.fire('Error', error, 'error');
    }
    dispatch(UIActions.uiLoadInactive());
}

export const recoveryPasswordUpdate = async (token, password, navigate, dispatch) => {
    try {
        const params = new URLSearchParams({
            token: token,
            password: encodeURIComponent(password)
        });
        const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/recovery/update?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    updateSuccess(navigate);
                } else {
                    Swal.fire('Error', data.userMessage, 'error');
                }
            });
    } catch (error) {
        Swal.fire('Error', error, 'error');
    }
    dispatch(UIActions.uiLoadInactive());
}

const updateSuccess = (navigate) => {
    Swal.fire({
        title: 'Se realizo el cambio de contraseña',
        text: "Es necesario inciar sesión con la nueva contraseña",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
    }).then((result) => {
        if (result.isConfirmed) {
            return navigate("/");
        }
    })
}

export const recoveryPasswordUpdateApp = async (token, password, dispatch) => {
    try {
        const params = new URLSearchParams({
            token: token,
            password: encodeURIComponent(password)
        });
        const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/recovery/update?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    updateSuccessApp();
                } else {
                    Swal.fire('Error', data.userMessage, 'error');
                }
            });
    } catch (error) {
        Swal.fire('Error', error, 'error');
    }
    dispatch(UIActions.uiLoadInactive());
}

const updateSuccessApp = () => {
    Swal.fire({
        title: 'Se realizo el cambio de contraseña',
        text: "Es necesario inciar sesión con la nueva contraseña",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
    }).then((result) => {
        if (result.isConfirmed) {
            closeTab();
        }
    })
}

const closeTab = () => {
    window.open("about:blank", "_self");
    window.close();
};